import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Banche } from 'my-lib-sanfelici/my-lib-sanfelici';
import { BancheService } from 'my-lib-sanfelici';



@Component({
  selector: 'app-banche-details',
  templateUrl: './banche-details.component.html',
  styleUrls: ['./banche-details.component.css']
})
export class BancheDetailsComponent implements OnInit {
  banca: Banche;
  id: string;
  constructor(
    private route: ActivatedRoute,
    private bancheservice: BancheService) { }

  ngOnInit() {
    this.id = this.route.snapshot.params.id;
    this.bancheservice.get(this.id).subscribe(b => this.banca = b);
  }

}
